<template>
  <button
    v-tooltip="{
      content,
      placement: 'top',
      offset: 8,
      classes: 'tooltip--new'
    }"
    type="button"
    class="automation-info-tooltip"
    :aria-label="ariaLabel || content"
    @click.stop
  >
    <img src="@/assets/img/info-text-panel-icon.svg" alt="" aria-hidden="true" />
  </button>
</template>

<script>
export default {
  name: 'FollowUpAutomationInfoTooltip',
  props: {
    content: {
      type: String,
      required: true
    },
    ariaLabel: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.automation-info-tooltip {
  display: inline-flex;
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  cursor: default;
}

.automation-info-tooltip img {
  width: 18px;
  height: 18px;
}

.automation-info-tooltip:hover,
.automation-info-tooltip:focus-visible {
  background: $ui-blue-soft;
  outline: 0;
}

.automation-info-tooltip:focus-visible {
  box-shadow: 0 0 0 2px rgba($ui-blue, .18);
}
</style>
